<mat-dialog-content class="mat-typography">
  <div style="flex-direction: row;display: flex;">
    <div>
      <button mat-icon-button class="back_icon" (click)="closeDialog()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
    </div>
    <div><h4 class="title" translate> Sub Organization View</h4></div>
  </div>

  <div class="details">
    <div style="text-align: center;"><h3 translate>Address Details</h3></div>
    <div translate>Suborganization Code    : {{SubOrgData?.sub_organization_code}}</div>
    <div translate>Suborganization Name    : {{SubOrgData?.sub_organization_name}}</div>
    <div translate>Suborganization Email   : {{SubOrgData?.email}}</div>
    <div translate>Suborganization Contact : {{SubOrgData?.contact_number}}</div>
    <div translate>Suborganization Address : {{SubOrgData?.address}}</div>
  </div>

  <div style="float: right;">
      <button mat-stroked-button (click)="closeDialog()" class="px-5 cancel_button" translate>
          Cancel
      </button>
  </div>
</mat-dialog-content>